import React, { ReactNode, CSSProperties } from 'react';
import './Column.css';

interface ColumnProps {
  children: ReactNode;
  xs?: string;
  sm?: string;
  md?: string;
  lg?: string;
  xl?: string;
  className?: string;
  style?: CSSProperties;
}

const Column = ({
  children,
  xs,
  sm,
  md,
  lg,
  xl,
  className = '',
  style = {},
}: ColumnProps) => {
  const getColClass = (size, prefix) => (size ? `${prefix}-${size}` : '');

  const colClasses = [
    getColClass(xs, 'col-xs'),
    getColClass(sm, 'col-sm'),
    getColClass(md, 'col-md'),
    getColClass(lg, 'col-lg'),
    getColClass(xl, 'col-xl'),
  ].join(' ');

  return (
    <div className={`col ${colClasses} ${className}`} style={style}>
      {children}
    </div>
  );
};

export default Column;
